import type { GuidebookPlace } from "./types"

interface Props {
  place: GuidebookPlace
  onClick: () => void
}

export function PlaceCard({ place, onClick }: Props) {
  const copy = place.en
  if (!copy) return null

  return (
    <button className="gb-place" onClick={onClick} type="button">
      <div className="gb-place__header">
        <span className="gb-place__name">{copy.name}</span>
        {place.area && <span className="gb-place__area">{place.area}</span>}
      </div>
      {copy.short && <p className="gb-place__short">{copy.short}</p>}
    </button>
  )
}
